module.exports = __webpack_public_path__ + "static/22-slideshow-5d12fc8da16253e4830b2db4f4aec825.jpg";